import { icons } from 'assets';
import { RouteAwareCrumbs } from 'Components/shared/breadcrumbs';
import { Tab, TabPanel, Tabs } from 'Components/shared/tab';
import TableDisplay from 'Components/shared/table';
import Text from 'Components/shared/text';
import { Status, TransactionType } from 'Components/shared/transactions';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useGetUsersTransactions } from 'services/transactionService';
import { currencyMap } from 'utils/constants/maps';
import { capitalize, convertDate } from 'utils/stringServices';
import styles from './history.module.css';

const dummyData = [
    {transactionType:"debit",details:"Payment Id: 23494384938383",date:"17/04/22 14:35",amount:15000, status:"cancelled"},
    {transactionType:"credit",details:"Payment Id: 23494384938383",date:"17/04/22 14:35",amount:25000, status:"completed"},
    {transactionType:"debit",details:"Payment Id: 23494384938383",date:"17/04/22 14:35",amount:35000, status:"pending"},
    {transactionType:"credit",details:"Payment Id: 23494384938383",date:"17/04/22 14:35",amount:45000, status:"completed"},

];
const format = Intl.NumberFormat("en-US");
const dateFormat = Intl.DateTimeFormat("en-GB");
const tableStructure = {
  0: {
    field: "transactionType",
    renderItem: (rowData) => <TransactionType type={rowData.type == "deposit" ? "credit" :"debit"} />,
    cellStyle: {},
  },
  1: {
    renderItem: (rowData) => (
      <Text style={{ fontWeight: "300" }}>
        {capitalize(rowData.type)}: <br /> {rowData.details}
      </Text>
    ),
    cellStyle: {
      minWidth: "220px",
    },
  },
  2: {
    renderItem: (rowData) => (
      <Text style={{ fontWeight: "300" }}>
        Date:
        <br /> {convertDate(rowData.timestamp)}
      </Text>
    ),
    cellStyle: {
      minWidth: "110px",
    },
  },
  3: {
    renderItem: (rowData) => <Status variant={rowData.status} />,
    cellStyle: {
      textAlign: "left",
    },
  },
  4: {
    renderItem: (rowData) => (
      <Text
        style={{
          display: "flex",
          alignItems: "center",
          justifySelf: "flex-end",
        }}
      >
        { `${currencyMap[rowData.currency] || "₦"} ${format.format(rowData.amount)}`}
      </Text>
    ),
    cellStyle: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      justifySelf: "flex-end",
      minWidth: "120px",
      flexGrow: 2,
      paddingRight: "24px",
    },
  },
};
const DebitCardTransactions = () => {
    const navigate = useNavigate();
    const [selectedTab, setSelectedTab] = useState(0);
    const handleChange = (e, tabIndex) => {
        setSelectedTab(tabIndex);
    }
    const {
        status: transactStatus,
        error: transactError,
        data: transactData,
      } = useGetUsersTransactions("card");
    const NameMap = {
        "/transaction-history/debit-card-transactions":"Debit Card Transactions",
        "/transaction-history": "Transaction History"
    }
    return (
        <div className={styles.root}>
            <Text variant="lg" tag="h1" style={{fontWeight:"700"}}>Debit Card Transactions</Text>
            <RouteAwareCrumbs nameMap={NameMap} />
            
            <div className={styles.contentContainer}>
                <Text variant="md2" tag="h2" style={{ fontWeight:"700",marginBottom:"24px"}}>Transactions</Text>
                <Tabs value={selectedTab} handleChange={handleChange} fullWidth>
                    <Tab label="All" />
                    <Tab label="Credit" />
                    <Tab label="Debit" />
                </Tabs>
                <TabPanel value={selectedTab} index={0}  >
                   <TableDisplay data={transactData || []} column={tableStructure}  />
                </TabPanel>
                <TabPanel value={selectedTab} index={1} >
                    <TableDisplay data={transactData || []} column={tableStructure} 
                    
                    emptyComponent="No records yet" />
                </TabPanel>
                <TabPanel value={selectedTab} index={2} >
                <TableDisplay data={transactData || []} column={tableStructure} 
                
                emptyComponent="No records yet" />
                </TabPanel>
            </div>
        </div>
    )
}

export default DebitCardTransactions;
